
<!-- Section: Team v.1 -->
<div class="container no-margin no-padding">
        <div class="row no-padding " style="padding:0px">
          <div class="col-md-4 col-sm-6 no-margin   view overlay zoom" style="padding:0px" *ngFor='let img of ["wurzelweg.jpg","hase_640.jpg","kunst_640.jpg","tgp_640.jpg","glas_640.jpg","farben_640.jpg"]'>
            <a  routerLink="/methoden" >  <img src="../../assets/img/gallery/{{img}}" class="img-fluid"></a>
          
                <!--
                <div class="mask flex-center waves-effect waves-light  rgba-stylish-strong" mdbWavesEffect>
                        <p class="white-text">Hier kann eint text erscheinen</p>
                </div>
                -->
          </div>
          
        </div>
      </div>

